var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloud35Dp000000Fill0Wght400Grad0Opsz40(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "40px",
    viewBox: "0 -960 960 960",
    width: "40px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M254-160q-89 0-151.5-62T40-373q0-78 49-137.67 49-59.66 125.67-73.33 21.66-95.33 96-155.33 74.33-60 170.66-60 113.67 0 192.17 81.5 78.5 81.5 78.5 196.5v16q71 1.33 119.5 50.83T920-332.67q0 71-50.83 121.84Q818.33-160 747.33-160H254Zm0-66.67h493.33q44 0 75-31t31-75q0-44-31-75t-75-31h-62v-82.66q0-88.34-60.16-149.84-60.17-61.5-146.5-61.5-86.34 0-146.84 61.5t-60.5 149.84H252q-60.67 0-103 42.66Q106.67-436 106.67-374q0 61.33 43 104.33t104.33 43ZM480-480Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud35Dp000000Fill0Wght400Grad0Opsz40);
export default __webpack_public_path__ + "static/media/cloud_35dp_000000_FILL0_wght400_GRAD0_opsz40.b2e14c0cc86359ecc148825d21b755d1.svg";
export { ForwardRef as ReactComponent };